import Vue from 'vue'
import Vuex from "vuex";
import module_principal from '@/store/module_principal'
import module_login from '@/store/module_login'
import module_pesquisa from '@/store/module_pesquisa'
import module_telegram from '@/store/module_telegram'
import module_alerta from '@/store/module_alerta'
import module_email from '@/store/module_email'

Vue.use(Vuex)
export default new Vuex.Store({
  modules: {
    modulePrincipal: module_principal,
    moduleLogin: module_login,
    moduleTelegram: module_telegram,
    modulePesquisa: module_pesquisa,
    moduleAlerta: module_alerta,
    moduleEmail: module_email,
  }
})